/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import { t_rec_arr, t_key } from '../types';
import fold from './fold';

type t_some_fn<V> = (val: V, key: t_key) => boolean;

export interface Some {
  /**
   * @public
   * @function f1.some
   * @param adt the array or record we will evaluate
   * @example
   *
   * ```ts
   * f1.some(v => v > 16, [16, 17, 18]) === true
   * ```
   *
   */
  <V>(fn: t_some_fn<V>, adt: t_rec_arr<V>): boolean;
  <V>(fn: t_some_fn<V>): (adt: t_rec_arr<V>) => boolean;
}

/**
 * @see Some
 */
export default <V>(fn: t_some_fn<V>, ra: t_rec_arr<V>): boolean => {
  return fold((acc: boolean, v, k) => acc || fn(v, k as t_key), false, ra);
};
